var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1206_7396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16425 10.4966V3.49881C8.16425 3.18949 8.04138 2.89284 7.82266 2.67412C7.60393 2.4554 7.30728 2.33252 6.99796 2.33252H2.3328C2.02348 2.33252 1.72682 2.4554 1.5081 2.67412C1.28938 2.89284 1.1665 3.18949 1.1665 3.49881V9.91341C1.1665 10.0681 1.22794 10.2164 1.3373 10.3258C1.44666 10.4351 1.59499 10.4966 1.74965 10.4966H2.91594",
    stroke: "#6A7282",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74741 10.4966H5.24854",
    stroke: "#6A7282",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0798 10.4967H12.2461C12.4007 10.4967 12.5491 10.4353 12.6584 10.3259C12.7678 10.2166 12.8292 10.0683 12.8292 9.9136V7.78511C12.829 7.65278 12.7838 7.52445 12.7009 7.42123L10.6716 4.88455C10.6171 4.81625 10.5479 4.76108 10.4691 4.72313C10.3904 4.68518 10.3041 4.66541 10.2167 4.66528H8.16406",
    stroke: "#6A7282",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91336 11.6629C10.5575 11.6629 11.0797 11.1407 11.0797 10.4966C11.0797 9.85249 10.5575 9.33032 9.91336 9.33032C9.26924 9.33032 8.74707 9.85249 8.74707 10.4966C8.74707 11.1407 9.26924 11.6629 9.91336 11.6629Z",
    stroke: "#6A7282",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08182 11.6629C4.72594 11.6629 5.24811 11.1407 5.24811 10.4966C5.24811 9.85249 4.72594 9.33032 4.08182 9.33032C3.43769 9.33032 2.91553 9.85249 2.91553 10.4966C2.91553 11.1407 3.43769 11.6629 4.08182 11.6629Z",
    stroke: "#6A7282",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1206_7396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9955,
    height: 13.9955,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTruck);
export default __webpack_public_path__ + "static/media/gray_truck.ed4eed679e773ece2afe958899d9b8e4.svg";
export { ForwardRef as ReactComponent };